export default __webpack_public_path__ + "static/media/learose3-2048w.52b0ac75.png";